<template>
  <div class="wrap-iframe">
    <iframe :src="iframeSrc"></iframe>
    <!-- <iframe src="https://teacher.liruwei.cn/"></iframe> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeSrc: ''
    }
  },
  mounted() {
    const userInfo = this.$store.state.userInfo || {}
    const paramObj = this.$route.query
    this.iframeSrc = paramObj.iframeSrc + '?userId=' + userInfo.userId + '&userName=' + userInfo.userName + '&timeStamp=' + Date.parse(new Date())
  }
}
</script>

<style lang="less" scoped>
.wrap-iframe iframe{
  width: calc(~'100vw - 240px');
  height: 100vh;
}
</style>
